export const SET_USERLOGIN_DATA = "SET_USERLOGIN_DATA";
export const ACTIVE_ROLE_DATA = "ACTIVE_ROLE_DATA";